module.exports = __webpack_public_path__ + "img/wheelchair.1439fd52.svg";